// Central Configuration File
// All credentials and settings are read from environment variables
// Use .env.local for development or .env.production for production
// Copy .env.example to get started - DO NOT commit .env.local or .env.production

export const config = {
  // AWS SES Email Configuration
  email: {
    provider: process.env.EMAIL_PROVIDER || 'SES', // 'SES' | 'AWS_SES' | 'BREVO' | 'GMAIL'
    ses: {
      host: process.env.AWS_SES_HOST || '',
      port: parseInt(process.env.AWS_SES_PORT || '587'),
      secure: false, // Use STARTTLS
      user: process.env.AWS_SES_USER || '',
      pass: process.env.AWS_SES_PASS || '',
      fromEmail: process.env.SES_FROM_EMAIL || '',
      fromName: process.env.SES_FROM_NAME || 'RelaxingRoutine',
    },
    // Legacy Brevo (kept for fallback)
    brevo: {
      host: process.env.BREVO_HOST || '',
      port: parseInt(process.env.BREVO_PORT || '587'),
      user: process.env.BREVO_USER || '',
      pass: process.env.BREVO_PASS || '',
      apiKey: process.env.BREVO_API_KEY || '',
    }
  },

  // Database Configuration
  database: {
    mongodb: {
      uri: process.env.MONGODB_URI || ''
    }
  },

  // AWS Configuration
  aws: {
    region: process.env.AWS_REGION || '',
    accessKeyId: process.env.AWS_ACCESS_KEY_ID || '',
    secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY || '',
    s3: {
      bucket: process.env.AWS_S3_BUCKET || '',
    },
    sns: {
      senderID: process.env.AWS_SNS_SENDER_ID || '', // 6 characters max for SMS sender ID
      monthlySpendLimit: process.env.AWS_SNS_MONTHLY_LIMIT || '5', // $5 monthly limit
      smsType: process.env.AWS_SNS_SMS_TYPE || 'Transactional', // For OTP messages
    }
  },

  // Payment Configuration
  payment: {
    provider: process.env.PAYMENT_PROVIDER || 'PAYU', // 'PAYU' | 'RAZORPAY'
    payu: {
      merchantKey: process.env.PAYU_MERCHANT_KEY || '',
      merchantSalt: process.env.PAYU_MERCHANT_SALT || '',
      mode: process.env.PAYU_MODE || 'test', // 'test' | 'production'
      testUrl: 'https://test.payu.in/_payment',
      productionUrl: 'https://secure.payu.in/_payment',
    },
    // Razorpay (deprecated - keeping for reference)
    razorpay: {
      keyId: process.env.RAZORPAY_KEY_ID || '',
      keySecret: process.env.RAZORPAY_KEY_SECRET || '',
    }
  },

  // AI Configuration
  ai: {
    openai: {
      apiKey: process.env.OPENAI_API_KEY || ''
    }
  },

  // SMS Configuration
  sms: {
    provider: process.env.SMS_PROVIDER || 'AWS_SNS', // 'AWS_SNS' | 'FAST2SMS' | 'BREVO'
    awsSns: {
      region: process.env.AWS_REGION || '',
      senderID: process.env.AWS_SNS_SENDER_ID || '',
      smsType: process.env.AWS_SNS_SMS_TYPE || 'Transactional',
      monthlySpendLimit: process.env.AWS_SNS_MONTHLY_LIMIT || '5'
    },
    fast2sms: {
      apiKey: process.env.FAST2SMS_API_KEY || '',
      apiUrl: process.env.FAST2SMS_API_URL || 'https://www.fast2sms.com/dev/bulkV2'
    },
    brevo: {
      apiKey: process.env.BREVO_SMS_API_KEY || '',
      apiUrl: process.env.BREVO_SMS_API_URL || 'https://api.brevo.com/v3/transactionalSMS/sms'
    }
  },

  // Application Configuration
  app: {
    env: process.env.NODE_ENV || 'development',
    url: process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3000',
    socketUrl: process.env.NEXT_PUBLIC_SOCKET_URL || 'http://localhost:3001',
    adminAccessCode: process.env.ADMIN_ACCESS_CODE || '',
  },

  // Feature Flags
  features: {
    enableSMS: true,
    enableEmailVerification: true,
    enablePayments: true,
    debugMode: true,
  }
};

// Helper functions to get specific configurations
export const getEmailConfig = () => {
  const provider = config.email.provider;
  if (provider === 'SES' || provider === 'AWS_SES') {
    return config.email.ses;
  } else if (provider === 'BREVO') {
    return config.email.brevo;
  }
  throw new Error(`Unsupported email provider: ${provider}`);
};

export const getSMSConfig = () => {
  const provider = config.sms.provider;
  if (provider === 'AWS_SNS') {
    return config.sms.awsSns;
  } else if (provider === 'FAST2SMS') {
    return config.sms.fast2sms;
  } else if (provider === 'BREVO') {
    return config.sms.brevo;
  }
  throw new Error(`Unsupported SMS provider: ${provider}`);
};

export default config;